import React,{useState,useEffect, useContext} from 'react';
import styled from '@emotion/styled';
import { ModalContainer,
  UIcon,
  IconContainer,
  StyleLabel,
  MainContentContainer1,
  SubmitContainer,
  StyleButton
 } from './CreateAdminUser';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useSettingModal } from '../../../../hooks/Context';
import { FetchSingleData } from '../../../../hooks/FetchData';
import { apiRequest } from '../../../../api';
import useAuth from '../../../../hooks/useAuth';
import {Waiting} from '.';
import apiCall from '../../../../utils/apiCall';
import { useQuery, useMutation } from '@tanstack/react-query';
import { NotificationContext } from '../../../../providers/notification';

interface Payload {
  Email?: string;
  Id?:string;
  ClaimName: string | undefined;
  ClaimValue: string | undefined;
}

interface Claim {
  Id: number;
  ClaimName: string;
  ClainValue: string;
}

const claimList = [
  {name:'Applicants',id:1},
  {name:'Applications',id:2},
  {name:'Approvals',id:3},
  
];
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

  const AddClaim = (props:any) => {
    const {setShowCancel,setModalContent,setShowModal} = useSettingModal();
    const [disableBtn,setDisableBtn] = useState<boolean>(false);
    const userData  = props.data?props.data:null;
    const name = userData?`${userData.FirstName} ${userData.MiddleName?userData.MiddleName:''} ${userData.LastName}`:'';
    const [userClaim, setUserClaim] = useState('');
    const remove = props.remove?props.remove:false;
    const {user} = useAuth();
    const {data:claimL,isLoading:claimLoading} = FetchSingleData('claim-list','api/Administration/users/GetClaimNameAndValues')
    let claimList:any =[];
    if(!claimLoading) claimList =  claimL && claimL.length > 0?claimL:[];
    const { showNotification } = useContext(NotificationContext);
   
    const getClaims = async(): Promise<Claim[]> => {
      return (await (apiCall().get('/Administration/users/GetClaimNameAndValues')))?.data
    }

    const { data, isLoading } = useQuery(['get-claim'], getClaims, {
      retry: 0,
      keepPreviousData: true,
      enabled: true
    })

    const handleChange = (event: SelectChangeEvent< string>) =>{
      setUserClaim(event.target.value);
    }

    const AddClaimToUser = async(data: Payload) => {
      return await(apiCall().post(remove?'/Administration/post/RemoveClaimFromUserAsync':'/Administration/post/AddClaimToUserAsync', data))
    };

    const AddClaimToUserMutation = useMutation(['add-claim'], AddClaimToUser, {retry: 0});

    const AddClaimToUserHandler = async(e:any) => {
      e.preventDefault();
      const claim = data?.find((data: Claim) => data.Id === Number(userClaim));

      const payload: Payload = !remove ? {
        Email: userData.Email,
        ClaimName: claim?.ClaimName,
        ClaimValue: claim?.ClainValue
      }:{
        Id: userData.UserId,
        ClaimName: claim?.ClaimName,
        ClaimValue: claim?.ClainValue
      }
      
       try {
        await AddClaimToUserMutation.mutateAsync(payload, {
          onSuccess: (data) => {
            if(!remove){
                showNotification({
                  type: 'success',
                  message: 'Claim successfully added to user',
                })
                setShowCancel(true);
                setShowModal(false);
              }
              else{
                if(remove){
                  showNotification({
                  type: 'success',
                  message: 'Claim successfully removed from user',
                })
                setShowCancel(true);
                setShowModal(false);
              }
            }
          }
        })
       }catch(error: any) {
        showNotification({
          type: 'error',
          message: error?.response?.data?.Message || error?.message,
        })
       }
    }

       
    return (
      <ModalContainer>
        <div>
          <div>
            <div>
              <IconContainer><UIcon /></IconContainer>
              <span>{!remove ?'Add Claim' :'Remove Claim'}</span>
              </div>
            </div>
            <MainContentContainer1 onSubmit={AddClaimToUserHandler}>
              <div>
                <span>Admin: </span>
                <span>{name}</span>
              </div>
              <StyleLabel className='full' style={{marginTop:"15px",marginBottom:"30px"}}>
                <span>Claim</span>
                <Select
                  
                  id="demo-select"
                  label="claim-select"
                  value={userClaim}
                  onChange={handleChange}
                  MenuProps={MenuProps}
                >
                  {data && data?.length > 0 && data.map((claim:Claim) => (
                    <MenuItem key={claim.Id} value={claim.Id}>
                      {claim.ClaimName}
                    </MenuItem>
                  ))}
                </Select>
              </StyleLabel>
              <SubmitContainer>
                 <span onClick={()=>setShowModal(false)}>Cancel</span>
                 <StyleButton disabled={disableBtn} type="submit" style={{backgroundColor:remove?'#DD5151':'#11643C'}}>
                  {remove?'Remove Claim':'Add Claim'}
                 </StyleButton>
              </SubmitContainer>
            </MainContentContainer1>

        </div>

   
      </ModalContainer>
      
    )
  }

export default AddClaim;
